import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
  } from "@angular/common/http";
  import { from, Observable, throwError } from "rxjs";
  import { catchError, switchMap } from "rxjs/operators";
  import { Router } from "@angular/router";
  import { Injectable } from "@angular/core";
  import { RedIApiService } from "../services/rediapi/redi-api.service";
  import { HeadersTerceros } from "./headers-terceros";
  @Injectable({ providedIn: "root" })
  export class HttpApiInterceptor implements HttpInterceptor {
    constructor(private router: Router, private redIApiService: RedIApiService) {}
    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      if (request.url.includes('token/obtener') || request.url.includes('assets')) {
        return next.handle(request)
      };
      if(request.url.includes('myperfit')) {
        const headers = HeadersTerceros.HeadersMyPerfitMO;
        request = request.clone({
          setHeaders: headers,
        });
        return next.handle(request);
      }
      /**Intercepta las request que no sean de obtener token o assets */
      return from(this.redIApiService.checkEstatus()).pipe(
        /**Setea los headers luego de chequear los tokens */
        switchMap(() => {
          const headers = this.redIApiService.getSessionHeaders();
          request = request.clone({
            setHeaders: headers,
          });
          return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status === 404) {
                console.log("Error cargando portal")
                // this.router.navigate(["not-found"]);
              }
              if (error.status === 500) {
                console.log("Error interno de servidor")
                // this.router.navigate(["internal-error"]);
              }
              return throwError(error);
            })
          );
        })
      );
    }
  }
  